var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditpen2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "#373A3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 842,
    transform: "translate(-458 -800)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 -8H-458V42H137V-8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.7,
    height: 34,
    rx: 17,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7722 20.0301C11.7089 20.0933 11.6664 20.1738 11.6483 20.2606L11.0088 23.4593C10.979 23.6076 11.026 23.7605 11.1327 23.8681C11.2187 23.9541 11.3344 24.0001 11.453 24.0001C11.4819 24.0001 11.5118 23.9975 11.5416 23.9912L14.7394 23.3517C14.828 23.3335 14.9085 23.2911 14.9709 23.2276L22.1279 16.0706L18.9302 12.873L11.7722 20.0301Z",
    fill: "#032339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3363 10.6615C23.4545 9.7795 22.0197 9.7795 21.1386 10.6615L19.8867 11.9134L23.0844 15.1111L24.3363 13.8591C24.7633 13.433 24.9985 12.8649 24.9985 12.2607C24.9985 11.6565 24.7633 11.0883 24.3363 10.6615Z",
    fill: "#032339"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 842,
    fill: "white",
    transform: "translate(-458 -800)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpen2);
export default __webpack_public_path__ + "static/media/Editpen2.3a0ce3c73ac53fec516f66707fe8dbc1.svg";
export { ForwardRef as ReactComponent };